import { ViewportPortal } from "@xyflow/react";
import type { CollaboratorCursor, PresenceClient } from "../types/board";

export function CollaboratorCursors({ cursors, presence, connectionId }: {
  cursors: CollaboratorCursor[]; presence: PresenceClient[]; connectionId: string | null;
}) {
  const members = new Map(presence.map(member => [member.connectionId, member]));
  return <ViewportPortal><div className="pointer-events-none" aria-hidden="true">
    {cursors.filter(cursor => cursor.connectionId !== connectionId && members.has(cursor.connectionId) &&
      Number.isFinite(cursor.x) && Number.isFinite(cursor.y) && Date.now() - cursor.seenAt < 5_000).map(cursor => {
      const member = members.get(cursor.connectionId)!;
      return <div key={cursor.connectionId} data-connection-id={cursor.connectionId}
        className="pointer-events-none absolute left-0 top-0 flex items-start gap-1 text-foreground"
        style={{ transform: `translate(${cursor.x}px, ${cursor.y}px)` }}>
        <svg width="14" height="20" viewBox="0 0 14 20" className="fill-foreground stroke-background" aria-hidden="true"><path d="M1 1v16l4-5 5 7 3-2-5-7h5Z" /></svg>
        <span className="rounded border bg-background px-1 py-0.5 text-xs text-foreground shadow-sm">{member.displayName || member.userId}</span>
      </div>;
    })}
  </div></ViewportPortal>;
}
